import { useQuery } from "@tanstack/react-query";

import type { InstallationStatus } from "@/lib/hubspot/installation-status";
import { fetchHubSpotInstallationStatus } from "@/services/frontendServices/hubspotAccountServices";

export const hubSpotInstallationStatusKeys = {
  all: ["hubspot", "installation-status"] as const,
};

/** Live Ampersand installation status for the Field Mappings screen. SKR-899. */
export const useHubSpotInstallationStatus = () => {
  return useQuery<InstallationStatus, Error>({
    queryKey: hubSpotInstallationStatusKeys.all,
    queryFn: fetchHubSpotInstallationStatus,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};
